const $ = jQuery.noConflict();

'use strict';

const RegularSearch = {
	itemsPerLoad: 12,
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		if ($('.js-search-page').length === 0) {
			return;
		}
		this.bindEvents();
	},

	/** @description Bind Events */
	bindEvents: function() {
		$('.js-search-field').on('input', this.handleInputChange.bind(this));
		$('.js-search-field-empty').on('click', this.clearField.bind(this));
		$('.js-search-field').on('keypress', (event) => this.pressEnter(event));

		$('.js-tab-content').each(function() {
			RegularSearch.initLazyLoad($(this));
		});
	},

	pressEnter: function(event) {
		const searchValue = $('.js-search-field').val().trim();
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault();
			if (searchValue.length >= 3) {
				const link = window.fwsLocalized.siteUrl + '?s=' + encodeURIComponent(searchValue);
				window.location.replace(link);
			}
		}
	},

	handleInputChange: function() {
		const inputValue = $('.js-search-field').val().trim();
		$('.js-quick-search').toggleClass(this.classActive, inputValue.length >= 3);
	},

	clearField: function() {
		$('.js-search-field').val('').focus();
	},

	/** @description Lazy load search results */
	initLazyLoad: function($tab) {
		const $list = $tab.find('.js-search-results-listing');
		const $items = $list.find('.search-results__list-item');
		const $summary = $tab.find('.search-results__summary span');
		const $loader = $tab.find('.js-search-results-loader');

		if (!$items.length) {
			return;
		}

		let index = Math.min(RegularSearch.itemsPerLoad, $items.length);
		$items.addClass('hidden-item').slice(0, index).removeClass('hidden-item');
		RegularSearch.updateSummary($items, index, $summary);

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting && index < $items.length) {
					$loader.fadeIn();

					setTimeout(() => {
						index = RegularSearch.showNextItems($items, index, RegularSearch.itemsPerLoad, $summary);
						$loader.fadeOut();

						const newLast = $items.get(index - 1);
						if (newLast) {
							observer.observe(newLast);
						}
					}, 400);

					observer.unobserve(entry.target);
				}
			});
		}, {
			root: null,
			threshold: 0.1
		});

		observer.observe($loader[0]);
	},

	updateSummary: function($items, index, $summary) {
		const totalCount = $items.length;
		const showingNow = Math.min(index, totalCount);
		//
		$summary.text(`1-${showingNow} of ${totalCount} Results`);
	},

	showNextItems: function($items, index, itemsPerLoad, $summary) {
		const newIndex = Math.min(index + itemsPerLoad, $items.length);
		$items.slice(index, newIndex).removeClass('hidden-item').css('display', 'block');
		//
		RegularSearch.updateSummary($items, newIndex, $summary);
		//
		return newIndex;
	}
};

export default RegularSearch;
